var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 3 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 10.1394C21.9188 10.1394 21.375 10.7495 21.375 11.5068V15.083H20.2875V11.9906H9V15.083H2.625V7.3205C2.625 6.56319 2.08125 5.95312 1.40625 5.95312C0.73125 5.95312 0.1875 6.56319 0.1875 7.3205V20.9732H2.625V18.1964H9V19.9635H20.2688V18.1964H21.3563V20.9732H23.7938V11.5068C23.8125 10.7495 23.2688 10.1394 22.5938 10.1394Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38739 13.8404L6.95614 14.1559C7.44364 14.219 7.85614 13.8193 7.91239 13.2934C7.96864 12.7465 7.61239 12.2837 7.14364 12.2206L4.57489 11.905C4.08739 11.8419 3.67489 12.2416 3.61864 12.7675C3.56239 13.2934 3.91864 13.7773 4.38739 13.8404Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedW);
export default __webpack_public_path__ + "static/media/BedW.e8bdc3a0cde5c383fc1ccf1a4857fa7b.svg";
export { ForwardRef as ReactComponent };